"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBlockedRect = void 0;
const react_1 = require("react");
const BlockingContentProvider_1 = require("../components/BlockingContentProvider");
function useBlockedRect(rect) {
    const { setBlockedRects } = react_1.useContext(BlockingContentProvider_1.BlockedRectContext);
    react_1.useEffect(() => {
        if (!rect) {
            return () => { };
        }
        setBlockedRects(oldRects => [...oldRects, rect]);
        return () => {
            setBlockedRects(oldRects => oldRects.filter(x => x !== rect));
        };
    }, [rect, setBlockedRects]);
}
exports.useBlockedRect = useBlockedRect;
//# sourceMappingURL=useBlockedRect.js.map